export const DEFAULT_MODULE_ID = 'E8';

export const PARKED_MODULE_IDS = new Set([
  'QRA',
  'Vulnerability',
  'CJ'
]);

export const isModuleAvailable = (moduleId) => !PARKED_MODULE_IDS.has(moduleId);

export const resolveAvailableModule = (moduleId) => (
  isModuleAvailable(moduleId) ? moduleId : DEFAULT_MODULE_ID
);
